module.exports = __webpack_public_path__ + "img/transform.23b17509.png";